export const API_BYID_CATEGORY =
  "https://cafe-notes-api.herokuapp.com/api/categories/";
